import './index-common';
import { CashierPaymentsWidget } from './components/CashierPaymentsWidget/index-tpa';
import { registerWidgetInRMC } from './components/CashierPaymentsWidget/utils/registerWidgetInRMC';

registerWidgetInRMC(CashierPaymentsWidget);

export { CashierPaymentsWidget };
